"use client";

import { isOauthCallbackPage } from "@/app/_components/AuthProvider/utils";
import { useCustomRouter } from "@/hooks/useCustomRouter";
import { Auth0Provider } from "@auth0/auth0-react";
import type React from "react";
import { memo } from "react";

type Props = {
  children: React.ReactNode;
};

export const AuthProvider = memo(({ children }: Props): React.JSX.Element => {
  const { pathname } = useCustomRouter();
  const isSkipRedirectCallback = isOauthCallbackPage(pathname);

  return (
    <Auth0Provider
      domain={process.env.NEXT_PUBLIC_AUTH0_DOMAIN || ""}
      clientId={process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID || ""}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      authorizationParams={{
        audience: process.env.NEXT_PUBLIC_AUTH0_AUDIENCE,
        redirect_uri:
          typeof window !== "undefined"
            ? window.location.origin + "/auth/callback"
            : "",
      }}
      skipRedirectCallback={isSkipRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
});
